import { useUserContext } from '@/hooks/use-user-context';
import { UserRole } from '@/lib/permissions/types';
import { useToast } from '../../hooks/use-toast';
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from '../ui/toast';

export function Toaster() {
  const { toasts } = useToast();
  const userContext = useUserContext();

  // Only show toasts to System Admins
  const isSystemAdmin =
    userContext?.is_system_admin === true ||
    userContext?.app_role === UserRole.ADMIN;

  if (!isSystemAdmin) {
    return null;
  }

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className='grid gap-1'>
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
